export const defaultTemplate = `
<section class="zambezi-grid-headers"></section>
<section class="zambezi-grid-body"></section>
<ul class="zambezi-grid-resizers"></ul>
<ul class="zambezi-grid-column-drop"></ul>
`
